import styled from "styled-components";

export const FormContainer = styled.form`
  display: flex;
  flex-direction: column;
  gap: 18px;
  width: 560px;
  max-width: 100%;
  padding-top: 4px;
`;

export const FieldRow = styled.div`
  display: grid;
  grid-template-columns: minmax(0, 1fr) 210px;
  gap: 14px;
`;

export const DateRow = styled.div`
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 14px;
`;

export const HelperText = styled.span`
  font-size: 11px;
  color: ${(props) => props.theme.brand.soft};
  text-align: end;
  margin-top: -12px;
`;

export const FormButtons = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-end;
  gap: 10px;
  padding-top: 4px;

  button.default-submit-button {
    background-color: ${(props) => props.theme.colors.primary} !important;
    color: white !important;
  }

  /* Cancel is the secondary action: it leaves the default filled style so it
     does not compete with Save. */
  button:not(.default-submit-button) {
    background-color: transparent !important;
    color: ${(props) => props.theme.brand.muted} !important;
    box-shadow: none !important;

    &:hover {
      background-color: #f5f8fb !important;
      color: ${(props) => props.theme.brand.navy} !important;
    }
  }
`;
